export default __webpack_public_path__ + "static/media/Domain-Driven Design Barcelona.6819f64f.png";